 const credential = {

    cloud_name :"ddj9k3axn",
    upload_preset:"ztuekn52"
    
 }


export default credential